import { render, staticRenderFns } from "./CoreBatchRunTable.vue?vue&type=template&id=284126a8&scoped=true"
import script from "./CoreBatchRunTable.vue?vue&type=script&lang=js"
export * from "./CoreBatchRunTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284126a8",
  null
  
)

export default component.exports